import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BILLING_ON } from "@/lib/bf";
import BFAppTabs from "./BFAppTabs";
import BFInvoicing from "./BFInvoicing";

export default function BFBillingPage() {
  if (!BILLING_ON) return <Navigate to="/black-friday-admin" replace />;
  return (
    <div className="st-app bfa" data-testid="bf-billing-page">
      <header className="st-top">
        <div className="st-brand">
          <Link to="/" className="st-btn st-btn--ghost" data-testid="bf-billing-back"><ArrowLeft size={16} /> Catalog</Link>
          <span className="st-brand-mark">Facturare <em>NeoManager</em></span>
        </div>
      </header>
      <BFAppTabs />
      <main className="users-main"><BFInvoicing /></main>
    </div>
  );
}
